import { Country, State, City } from "country-state-city";
var COUNTRY_ISO_ALIASES = {
    "usa": "US",
    "united states": "US",
    "uk": "GB",
    "united kingdom": "GB",
    "uae": "AE",
    "united arab emirates": "AE",
    "south korea": "KR",
    "north korea": "KP",
};
export function getCountryIso(countryName) {
    var _a, _b;
    var lower = countryName.toLowerCase();
    if (COUNTRY_ISO_ALIASES[lower])
        return COUNTRY_ISO_ALIASES[lower];
    return (_b = (_a = Country.getAllCountries().find(function (c) { return c.name.toLowerCase() === lower; })) === null || _a === void 0 ? void 0 : _a.isoCode) !== null && _b !== void 0 ? _b : null;
}
export function resolveMarkerCoords(drillPath, label) {
    var _a;
    if (drillPath.length === 0) {
        var iso = getCountryIso(label);
        if (!iso)
            return [0, 20];
        var c = Country.getCountryByCode(iso);
        if ((c === null || c === void 0 ? void 0 : c.latitude) && (c === null || c === void 0 ? void 0 : c.longitude))
            return [parseFloat(c.longitude), parseFloat(c.latitude)];
        return [0, 20];
    }
    var countryIso = getCountryIso(drillPath[0]);
    if (!countryIso)
        return null;
    if (drillPath.length === 1) {
        var lower_1 = label.toLowerCase();
        var state_1 = State.getStatesOfCountry(countryIso).find(function (s) { return s.name.toLowerCase() === lower_1; });
        if (!(state_1 === null || state_1 === void 0 ? void 0 : state_1.latitude) || !(state_1 === null || state_1 === void 0 ? void 0 : state_1.longitude))
            return null;
        return [parseFloat(state_1.longitude), parseFloat(state_1.latitude)];
    }
    var stateIso = (_a = State.getStatesOfCountry(countryIso).find(function (s) { return s.name.toLowerCase() === drillPath[1].toLowerCase(); })) === null || _a === void 0 ? void 0 : _a.isoCode;
    if (!stateIso)
        return null;
    if (drillPath.length === 2) {
        var lower_2 = label.toLowerCase();
        var city_1 = City.getCitiesOfState(countryIso, stateIso).find(function (c) { return c.name.toLowerCase() === lower_2; });
        if ((city_1 === null || city_1 === void 0 ? void 0 : city_1.latitude) && (city_1 === null || city_1 === void 0 ? void 0 : city_1.longitude)) {
            return [parseFloat(city_1.longitude), parseFloat(city_1.latitude)];
        }
        var state_2 = State.getStatesOfCountry(countryIso).find(function (s) { return s.isoCode === stateIso; });
        if ((state_2 === null || state_2 === void 0 ? void 0 : state_2.latitude) && (state_2 === null || state_2 === void 0 ? void 0 : state_2.longitude))
            return [parseFloat(state_2.longitude), parseFloat(state_2.latitude)];
        return null;
    }
    var cityName = drillPath[2].toLowerCase();
    var city = City.getCitiesOfState(countryIso, stateIso).find(function (c) { return c.name.toLowerCase() === cityName; });
    if ((city === null || city === void 0 ? void 0 : city.latitude) && (city === null || city === void 0 ? void 0 : city.longitude)) {
        return [parseFloat(city.longitude), parseFloat(city.latitude)];
    }
    var state = State.getStatesOfCountry(countryIso).find(function (s) { return s.isoCode === stateIso; });
    if ((state === null || state === void 0 ? void 0 : state.latitude) && (state === null || state === void 0 ? void 0 : state.longitude))
        return [parseFloat(state.longitude), parseFloat(state.latitude)];
    return null;
}
export function getDefaultDateRange() {
    var end = new Date();
    var start = new Date();
    start.setDate(start.getDate() - 30);
    var formatDate = function (d) {
        var year = d.getFullYear();
        var month = String(d.getMonth() + 1).padStart(2, '0');
        var day = String(d.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
        startDate: formatDate(start),
        endDate: formatDate(end),
    };
}
export function buildHashmaps(rows) {
    var _a, _b, _c, _d;
    var countryAcc = {};
    var stateAcc = {};
    var cityAcc = {};
    var zipAcc = {};
    var init = function () { return ({ sales: 0, orders: 0, customerSet: new Set(), repSet: new Set(), repNames: new Set() }); };
    var accumulate = function (acc, key, row) {
        if (!acc[key])
            acc[key] = init();
        acc[key].sales += row.SubTotal;
        acc[key].orders += 1;
        acc[key].customerSet.add(row.CustomerId);
        acc[key].repSet.add(row.SalesRepId);
        acc[key].repNames.add(row.SalesRepName);
    };
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var row = rows_1[_i];
        var c = (_a = row.ShippingCountry) !== null && _a !== void 0 ? _a : "NA";
        var s = (_b = row.ShippingProvince) !== null && _b !== void 0 ? _b : "NA";
        var ci = (_c = row.ShippingCity) !== null && _c !== void 0 ? _c : "NA";
        var z = (_d = row.ShippingZip) !== null && _d !== void 0 ? _d : "NA";
        accumulate(countryAcc, c, row);
        accumulate(stateAcc, "".concat(c, "||").concat(s), row);
        accumulate(cityAcc, "".concat(c, "||").concat(s, "||").concat(ci), row);
        accumulate(zipAcc, "".concat(c, "||").concat(s, "||").concat(ci, "||").concat(z), row);
    }
    var finalize = function (acc) {
        var result = {};
        for (var _i = 0, _a = Object.keys(acc); _i < _a.length; _i++) {
            var key = _a[_i];
            result[key] = {
                sales: acc[key].sales,
                orders: acc[key].orders,
                customers: acc[key].customerSet.size,
                salesRepCount: acc[key].repSet.size,
                salesRepNames: Array.from(acc[key].repNames),
            };
        }
        return result;
    };
    return {
        byCountry: finalize(countryAcc),
        byState: finalize(stateAcc),
        byCity: finalize(cityAcc),
        byZip: finalize(zipAcc),
    };
}
export function getCountryCenter(countryName) {
    var iso = getCountryIso(countryName);
    if (!iso)
        return null;
    var c = Country.getCountryByCode(iso);
    if ((c === null || c === void 0 ? void 0 : c.latitude) && (c === null || c === void 0 ? void 0 : c.longitude))
        return [parseFloat(c.longitude), parseFloat(c.latitude)];
    return null;
}
